import React from 'react';
import { ScreenSwapRoute } from '../shared/routes/ScreenSwapRoute';
import { FortuneExchange } from './exchange/FortuneExchange';
import { FortuneExchangeHistory } from './exchangeHistory/FortuneExchangeHistory';
import { FortuneHome } from './home/FortuneHome';

const Fortune: React.FC = () => {
  return (
    <>
      <ScreenSwapRoute path="/players/fortune/home">
        <FortuneHome />
      </ScreenSwapRoute>
      <ScreenSwapRoute path="/players/fortune/exchange">
        <FortuneExchange />
      </ScreenSwapRoute>
      <ScreenSwapRoute path="/players/fortune/exchange-history">
        <FortuneExchangeHistory />
      </ScreenSwapRoute>
    </>
  );
};

export default Fortune;
